// extracted by mini-css-extract-plugin
export const grid = "card-grid-wrapper-module--grid--1rFs8";